import { Certificate } from "../../Certificate";

interface PublicFormProps {
  handleChange: (event: any) => void;
  isDateInvoiceActive: string;
  data: Certificate;
}

export default function PublicForm({
  handleChange,
  isDateInvoiceActive,
  data,
}: PublicFormProps) {
  const certMode = isDateInvoiceActive === "date";
  const invoiceMode = isDateInvoiceActive === "date_invoice";

  return (
    <>
      <div className="flex flex-col w-full sm:w-2/3  text-left">
        <label htmlFor={"date"}>
          дата выпуска сертификата
          {!invoiceMode && <span className="text-red-600">*</span>}
        </label>
        <input
          type="date"
          required={!invoiceMode}
          name="date"
          id="date"
          onChange={(event) => handleChange(event)}
          minLength={4}
          disabled={invoiceMode}
          value={data.date || ""}
          className="px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4] disabled:bg-[#f0f0f0] disabled:text-[#9a9a9a]"
        />
      </div>
      <div className="flex flex-col w-full sm:w-2/3  text-left">
        <label htmlFor="certification_number">
          номер сертификата
          {certMode && <span className="text-red-600">*</span>}
        </label>
        <input
          type="text"
          name="certification_number"
          id="certification_number"
          onChange={(event) => handleChange(event)}
          minLength={4}
          required={certMode}
          disabled={invoiceMode}
          className="px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4] disabled:bg-[#f0f0f0] disabled:text-[#9a9a9a]"
          value={data.certification_number || ""}
        />
      </div>
      <div className="flex flex-col w-full sm:w-2/3  text-left">
        <label htmlFor="date_invoice">
          дата выпуска накладной
          {!certMode && <span className="text-red-600">*</span>}
        </label>
        <input
          type="date"
          required={!certMode}
          name="date_invoice"
          id="date_invoice"
          onChange={(event) => handleChange(event)}
          minLength={4}
          disabled={certMode}
          value={data.date_invoice || ""}
          className="px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4] disabled:bg-[#f0f0f0] disabled:text-[#9a9a9a]"
        />
      </div>
      <div className="flex flex-col w-full sm:w-2/3  text-left">
        <label htmlFor="gov_number">
          номер вагона (гос. номер)
          {invoiceMode && <span className="text-red-600">*</span>}
        </label>
        <input
          type="text"
          name="gov_number"
          id="gov_number"
          onChange={(event) => handleChange(event)}
          minLength={4}
          required={invoiceMode}
          disabled={certMode}
          className="px-3 focus:border-primary  py-4 md:px-6 md:py-5 border outline-none border-[#d3d3d4] disabled:bg-[#f0f0f0] disabled:text-[#9a9a9a]"
          value={data.gov_number || ""}
        />
      </div>
    </>
  );
}
